import React from "react";
import { Form, message, Radio } from "antd";
import PractitionerSearch from "./PractitionerSearch";
import PractitionerInformation from "./PractitionerInformation";
import SpecimentField from "./SpecimenField";

export default function Examination({
  onPractitionerChange,
  patientId,
  questionnaireCode,
}) {
  const [practitioner, setPractitioner] = React.useState(null);

  return (
    <>
      <Form.Item
        rules={[
          { required: true, message: "Tienes que elegir un tipo de examen" },
        ]}
        name="questionnaireCode"
        label="Examen"
      >
        <Radio.Group>
          <Radio value="24331-1">Perfil Lipídico</Radio>
          <Radio value="24325-3">Perfil Hepático</Radio>
        </Radio.Group>
      </Form.Item>
      <SpecimentField patientId={patientId} />
      <PractitionerSearch
        onSuccess={(value) => {
          setPractitioner(value);
          onPractitionerChange(value);
        }}
        onError={(run) =>
          message.warn(`No encontramos al informante con RUN '${run}'`)
        }
      />
      {practitioner && <PractitionerInformation practitioner={practitioner} />}
    </>
  );
}
